export default __webpack_public_path__ + "static/media/project-3.e817ff1b.jpeg";